export default "__VITE_ASSET__C$uDh4h2__"